/** load default settings from BU... these values will not change so there should not be any state changes associated with this */
import * as aseptic from '../settings/aseptic';
import * as proseal from '../settings/proseal';
import * as pna from '../settings/pna';
import * as avure from '../settings/avure';
import * as pemea from '../settings/pemea';
import * as dsi from '../settings/dsi';
import * as protein from '../settings/protein';
import * as stnik from '../settings/stnik'
import * as marel from '../settings/marel'

import { useMachineInfo } from './useMachineInfoProvider';

export interface UseBuSettingsProps {
  colors?: Record<string, string>;
  Icons?: Record<string, JSX.Element>;
  mapKeys?: Record<string, string>;
  kpis?: Record<string, Record<string, unknown>>;
  [key: string]: unknown;
}

const buSettings: Record<string, unknown> = { stnik, aseptic, proseal, pna, avure, pemea, dsi, protein, marel };

export const useBuSettings = (bu?: string): UseBuSettingsProps => {
  const { businessUnit } = useMachineInfo();
  bu = bu || businessUnit;
  return !bu ? {} : (buSettings?.[bu] as UseBuSettingsProps);
};
